import React from 'react';
import { ApolloError } from '@apollo/client';

import { Typography, CircularProgress, LinearProgress } from '@occc/ui-design-system';

import { AudienceFormRenderProps } from '../types';

interface AudienceUpdateFormProps extends Pick<AudienceFormRenderProps, 'handleSubmit'> {
  children?: React.ReactNode;
  loading: boolean;
  loaded: boolean;
  error?: ApolloError;
}

export const AudienceUpdateForm: React.FC<AudienceUpdateFormProps> = ({
  handleSubmit,
  loading,
  loaded,
  error,
  children,
}) => {
  if (error) {
    return <Typography color='error'>Something went wrong. Please try again.</Typography>;
  }
  // initially loading
  if (loading && !loaded) {
    return <CircularProgress />;
  }

  if (!loaded) {
    return <Typography color='error'>No data. Something went wrong. Please try again.</Typography>;
  }

  return (
    <form onSubmit={handleSubmit}>
      {loading && <LinearProgress />}
      {children}
    </form>
  );
};
